export default "__VITE_ASSET__$C1rWpCW__"